class CartBackendResponseError extends Error {
  constructor(message) {
    super(message);
    this.name = 'CartBackendResponseError';
  }
}

// eslint-disable-next-line import/prefer-default-export
export { CartBackendResponseError };
